import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { BoqMiTypeWiseModel } from 'src/app/models/department-reports.model';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-boq-mi-type-report',
  templateUrl: './boq-mi-type-report.component.html',
  styleUrls: ['./boq-mi-type-report.component.scss']
})
export class BoqMiTypeReportComponent implements OnInit {
  totalApp:number;
  verfApp:number;
  boqAmount:number;
  miArea:number;
  grandTotalApp:number;
  grandVerfApp:number;
  grandBoqAmount:number;
  grandMiArea:number;
  arrayIndex:number;
  tempMiType: any[];
  miType: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: BoqMiTypeWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  drilldownDetails:any;
  value:any
  public subscriptions: any = [];
  public loading: boolean = false;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "MiType_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "MiType_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getBoq_MiType_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'BOQ Report (MI Type)', '', new Date(), 'Success');

            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.miType = data;
              this.tempMiType=data;
              this.appVerificationModel = data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.miType = [];
              this.tempMiType=[];
              this.appVerificationModel = [];
              this.arrayIndex=0;
              this.calculateGrandTotal()
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'BOQ Report (MI Type)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }
  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "District" : d.District,
          "Block" : d.Block,
          "MIType" : d.MIType,
          "Total Application": d.TotalApplication,
          "Verified Application": d.VerifiedApplication,
          "BOQAmount" : d.BOQAmount,
          "Mi_Area" : d.Mi_Area,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'District', header: 'District'},
      {field: 'Block', header: 'Block'},
      { field: 'TotalApplication', header: 'Total Application' },
      { field: 'VerifiedApplication', header: 'Verified Application' },
      {field: 'BOQAmount', header: 'BOQ Amount'},
      {field: 'Mi_Area', header: 'Mi Area'},

     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempMiType=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
    onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
       // console.log(event);
      }
      calculateTotalApp() {
        this.totalApp=0;
        this.verfApp=0;
        this.boqAmount=0;
        this.miArea=0;      
        for(let i=this.arrayIndex ;this.tempMiType.length>10?i<this.arrayIndex+10:i<this.tempMiType.length;i++) {
          this.totalApp +=this.tempMiType[i].TotalApplication;
          this.verfApp +=this.tempMiType[i].VerifiedApplication;
          this.boqAmount += this.tempMiType[i].BOQAmount;
          this.miArea +=this.tempMiType[i].Mi_Area;
        }     
    }

    calculateGrandTotal(){
      this.grandTotalApp=0;
      this.grandVerfApp=0;
      this.grandBoqAmount=0;
      this.grandMiArea=0;
      for(let miData of this.miType) {
        this.grandTotalApp += miData.TotalApplication;
        this.grandVerfApp += miData.VerifiedApplication;
        this.grandBoqAmount += miData.BOQAmount;
        this.grandMiArea += miData.Mi_Area;
    }
    }

    showMaximizableDialog(value:any,status:any,block:any,miType:any) {
      
      
      this.value=value;
      this.drilldownDetails={
        actionType:"BOQ",
        
        filterType:"District",
        value:this.value,
        status:status,
        MIType:miType,
        Block:block
      }
      
      this.displayMaximizable = true;
      // console.log(this.value,"value")
      // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }
  showMaximizableDialog_totalApp(value:any,block:any,miType:any) {
        
        
    this.value=value;
    this.drilldownDetails={
      actionType:"BOQ",
      
      filterType:"District",
      value:this.value,
      MIType:miType,
      Block:block
    }
    
    this.displayMaximizable_totalApp = true;
  
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }

}
